// extracted by mini-css-extract-plugin
export var center = "HeaderLogo-module--center--Jsd-e";
export var component = "HeaderLogo-module--component--7jHdJ";
export var left = "HeaderLogo-module--left--X2XDS";
export var link = "HeaderLogo-module--link--AmSDF";
export var right = "HeaderLogo-module--right--aIZfv";